<template>
  <label class="mt-checkbox mt-checkbox-outline" :id="field.name">
    {{ field.label }}
    <input :data-vv-as="field.description.replace(/\./g, '')"
           :name="field.name"
           type="checkbox"
           v-validate="{required: required && !field.hide}"
           :disabled="locked"
           :readonly="locked"
           :value="field.label"
           :checked="!!value"
           @change="$emit('input', $event.target.checked ? field.label : '')"
    />
    <!-- XXX: this span is required for custom checkbox to display icon -->
    <span></span>
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    }
  },

  emits: ['input'],

  setup() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.mt-checkbox {
  display: block;
}
</style>




// WEBPACK FOOTER //
// CheckboxRender.vue?3bd2b1d3